import { useEffect, useState, useRef } from "react";
import { api } from "./api";
import { useI18n } from "./I18nContext";

export default function NotificationBell() {
  const { t, lang } = useI18n();
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);
  const ref = useRef(null);

  const load = async () => {
    try {
      const { data } = await api.get("/notifications");
      setItems(data);
    } catch (e) {
      /* noop */
    }
  };

  useEffect(() => {
    load();
    const i = setInterval(load, 30000);
    return () => clearInterval(i);
  }, []);

  useEffect(() => {
    const onClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const unread = items.filter((n) => !n.read).length;

  const markAll = async (e) => {
    e.stopPropagation();
    try {
      await api.put("/notifications/read-all");
      setItems((cur) => cur.map((n) => ({ ...n, read: true })));
    } catch (e) {
      /* noop */
    }
  };

  const clickItem = async (n) => {
    if (!n.read) {
      try {
        await api.put(`/notifications/${n.id}/read`);
      } catch (e) {
        /* noop */
      }
    }
    setOpen(false);
    if (n.link) window.location.href = n.link;
  };

  return (
    <div ref={ref} style={{ position: "relative" }}>
      <button
        className="tb-icon-btn"
        onClick={() => setOpen((o) => !o)}
        data-testid="notif-bell"
        aria-label="Notifications"
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9" />
          <path d="M13.73 21a2 2 0 0 1-3.46 0" />
        </svg>
        {unread > 0 && <span className="tb-notif-badge">{unread}</span>}
      </button>
      {open && (
        <div className="tb-notif-panel" data-testid="notif-panel">
          <div style={{ display: "flex", justifyContent: "space-between", padding: "6px 14px 10px" }}>
            <strong>{t("notif.title")}</strong>
            {unread > 0 && (
              <button className="tb-ghost-btn" style={{ padding: "3px 8px", fontSize: "0.75rem" }} onClick={markAll} data-testid="notif-mark-all">
                {t("notif.markAllRead")}
              </button>
            )}
          </div>
          {items.length === 0 ? (
            <div className="tb-notif-empty">{t("notif.none")}</div>
          ) : (
            items.map((n) => (
              <div
                key={n.id}
                className={`tb-notif-item ${n.read ? "" : "unread"}`}
                onClick={() => clickItem(n)}
                data-testid={`notif-item-${n.id}`}
              >
                <strong>{lang === "fr" ? n.title_fr : n.title_en}</strong>
                <span className="tb-muted" style={{ fontSize: "0.82rem" }}>
                  {lang === "fr" ? n.body_fr : n.body_en}
                </span>
                <small>{new Date(n.created_at).toLocaleString(lang === "fr" ? "fr-CA" : "en-US")}</small>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
}
